import { forwardRef } from 'react';

const Box: React.FC<any> = forwardRef(
  (
    {
      as: Component = 'div',
      cursor,
      children,
      lineHeight,
      backgroundColor,
      border,
      borderRadius,
      color,
      overflow,
      minHeight,
      height,
      margin,
      padding,
      width,
      textAlign,
      transition,
      maxHeight,
      display,
      position,
      top,
      left,
      right,
      bottom,
      fontSize,
      fontWeight,
      maxWidth,
      style,
      ...props
    },
    ref,
  ) => {
    return (
      <>
        <Component
          {...props}
          ref={ref}
          style={{
            cursor,
            border,
            backgroundColor,
            borderRadius,
            lineHeight,
            color,
            overflow,
            minHeight,
            margin,
            padding,
            width,
            textAlign,
            height,
            transition,
            maxHeight,
            display,
            position,
            top,
            left,
            fontWeight,
            right,
            fontSize,
            bottom,
            maxWidth,
            ...style,
          }}
        >
          {children}
        </Component>
      </>
    );
  },
);

export default Box;
